package fr.frux.core.database

import kotlin.Long
import kotlin.String

public data class Site_planting(
  public val id: Long,
  public val site_id: Long,
  public val species_id: Long,
  public val species_common_name_fr: String,
  public val species_scientific_name: String,
  public val species_form: String,
  public val count_estimate: String,
  public val note: String?,
)
